import { Component, Input, OnInit } from '@angular/core';
import { AviationEvent } from '../../shared/models/aviation-event.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { EditEventContactComponent } from '../edit-event-contact/edit-event-contact.component';
import { MatDialog, MatDialogConfig, MatDialogRef, MatSnackBar } from '@angular/material';
import { BusinessManagerService } from '../../shared/user/business-manager.service';


@Component({
  selector: 'app-event-contact',
  templateUrl: './event-contact.component.html',
  styleUrls: ['./event-contact.component.scss']
})
export class EventContactComponent implements OnInit {
  @Input() aviationEvent: AviationEvent;
  editModeSet = false;
  isFlightDeckAdmin = false;

  constructor(private _editDescDialog: MatDialog,
              private _toggleService: EditToggleService,
              public snackBar: MatSnackBar,
              private _businessManagerService: BusinessManagerService) { }

  async ngOnInit() {
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
    this.isFlightDeckAdmin = await this._businessManagerService.isFlightDeckAdmin();
  }

  get contactEmailAddress(): string {
    return 'mailto:' + this.aviationEvent.contactPersonEmail;
  }

  get contactPhone(): string {
    return 'tel:' + this.aviationEvent.contactPersonEmail;
  }

  openEditTitleDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '800px';
    dialogConfig.data = {aviationEvent: this.aviationEvent};

    const DIALOG_REF = this._editDescDialog.open(EditEventContactComponent, dialogConfig);
    this._handleModalClose(DIALOG_REF);
  }

  /**
   * listens for dialog close event. Opens snackbar if necessary
   * @param {MatDialogRef<any>} dialogRef
   * @private
   */
  _handleModalClose ( dialogRef: MatDialogRef<any>) {
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';

    dialogRef.afterClosed().subscribe((success) => {
      if (success === null) { return; }
      if (success) {
        this.snackBar.open('Event Contact', 'Updated', {
          duration: 3000
        });
      } else {
        this.snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
